import React from 'react';
import { CredentialsProvider } from './contexts/CredentialsContext';
import AppContent from './AppContent';
import './App.css';

function App() {
  return (
    <CredentialsProvider>
      <AppContent />
    </CredentialsProvider>
  );
}

export default App;
